const Layout = () => import('@/layout/index.vue');
export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/ZLogin/index.vue'),
    },
    // {
    //     path: '/register',
    //     component: () => import('@/views/register/index'),
    // },
    {
        path: "/mobile-warning",
        component: Layout,
        meta: {
            title: "温馨提示",
            visible: false,
        }, children: [
            {
                path: "/mobile-warning",
                component: () => import("@/layout/ZMobileWarning.vue"),
                meta: {
                    title: "温馨提示",
                    visible: true,
                    // icon: 'HomeOutlined'
                }
            },

        ]
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/exception/404.vue'),
    },
]